export const AMERICAN_MENU = {
    section1: [
        {
            name: 'House Salad',
            correct: true,
            message: ['A salad is always a great choice! You may want to ask for dressing on the side and be careful not to use too much.']
        },
        {
            name: 'Onion Rings',
            correct: false,
            message: [
                `You should avoid anything that's breaded and fried.`,
                `Please make a different selection from the list of Starters.`,
            ]
        },
        {
            name: 'Fried Mac and Cheese Bites',
            correct: false,
            message: [
                `You should avoid anything that's breaded and fried.`,
                `Please make a different selection from the list of Starters.`,
            ]
        },
        {
            name: 'Waffle Fries',
            correct: true,
            message: [
                `Ordering french fries, or in this case waffle fries, is fine as long as you remember to follow the plate method's serving suggestion. Waffle fries fall into the starch category and should be limited to a quarter of your plate.`,
            ]
        },
        {
            name: 'Chicken Fingers',
            correct: false,
            message: [
                `You should avoid anything that's breaded and fried.`,
                `Please make a different selection from the list of Starters.`
            ]
        },
    ],
    section2: [
        {
            name: `Custom Burger`,
            correct: true,
            message: [
                `If you're having a burger, opt for a whole grain bun or ask for a bunless burger if that's an option. Also, try to aim for an alternative like a turkey burger or veggie burger to cut down on the fat and salt content. And, as always, skip the cheese and mayo.`,
            ]
        },
        {
            name: `Double Bacon Cheeseburger`,
            correct: false,
            message: [
                `This option is a no-go for many reasons. With the extra helpings of meat patties and cheese, you're already looking at a bad choice. Throw in bacon which has a high sodium content, and it's easy to see this is setting you up to fail at sticking to the plate method.`,
            ]
        },
        {
            name: `Grilled Chicken Caesar Wrap`,
            correct: true,
            message: [
                `Having a sandwich wrap rather than a burger is going to be the better choice since it cuts out some of the carbs you'd be getting from the bread. Go for a whole grain or spinach tortilla rather than white flour, and ask for a light amount of dressing and cheese.`,
            ]
        },
        {
            name: `Turkey Spinach Wrap`,
            correct: true,
            message: [
                `Yes, yes, yes! Turkey is a lean meat and will be a better choice than a beef hamburger. With the addition of spinach and other veggies, you're going to meet a lot of areas of the plate method in this one sandwich wrap. Go for a whole grain or spinach tortilla rather than white flour, and ask for a light amount of dressing.`,
            ]
        },
        {
            name: `Mediterrenean Veggie Wrap`,
            correct: true,
            message: [
                `Excellent choice! As long as you don't overdo it in terms of dressing or cheese, a veggie wrap is going to be an easy win. Opting for a wrap instead of a burger cuts the carbohydrates that you'd be getting with bread, but you should still aim for a whole grain or spinach tortilla.`,
            ]
        }
    ],
    section3: [
        {
            name: `Baked Salmon`,
            correct: true,
            message: [
                `Baked or grilled fish is a great choice. It pairs perfectly with some steamed veggies and rice. Just be sure to watch your portion sizes.`,
            ]
        },
        {
            name: `Hearty Meatloaf Plate`,
            correct: false,
            message: [
                `This is a tricky one. Meatloaf dinners at restaurants are generally well over the portion size for your allotted protein, and it often comes covered in a sweet, sugary sauce and loads of mashed potatoes.`,
                `Please make a different selection.`
            ]
        },
        {
            name: `Southern Fried Chicken`,
            correct: false,
            message: [
                `As tempting as it may be, you should avoid fried foods. Not only that, but fried chicken dishes are often loaded with sodium in the breading.`,
                `Please make a different selection.`
            ]
        },
        {
            name: `Pan-Seared Garlic Chicken`,
            correct: true,
            message: [
                `Excellent choice! Always skip chicken that's been fried with breading. Pair this with a side salad or a modest helping of potatoes, and you're all set.`,
            ]
        },
        {
            name: `Stuffed Portabella Mushrooms (Vegan)`,
            correct: true,
            message: [
                `Great! Not only do you cut out the risk of consuming too much meat by ordering this mushroom dish, you also cut the risk of overindulging on cheese by ordering a vegan dish. This is a win-win!`,
            ]
        }
    ],
    section4: [
        {
            name: `Seasoned Steak Fries`,
            correct: true,
            message: [
                `As long as you stick within the 1/4 plate serving size, having fries with your meal is totally fine. Good job!`,
            ]
        },
        {
            name: `Fully-Loaded Baked Potato`,
            correct: false,
            message: [
                `With all the sour cream, cheese, and bacon among other toppings, this is not a great choice. If you want a baked potato, choose a plain baked potato instead.`,
                `Please make a different selection.`
            ]
        },
        {
            name: `Regular Baked Potato`,
            correct: true,
            message: [
                `Perfect! Just make sure butter and salt come on the side and be mindful of not loading it with too much of either. Using margarine instead of butter is also a great alternative.`,
            ]
        },
        {
            name: `Steamed Broccoli`,
            correct: true,
            message: [
                `Steamed vegetables, especially of the non-starchy type like broccoli, are a great choice for pairing with your meal. Well done!`,
            ]
        },
        {
            name: `Cup of Soup or Chili`,
            correct: true,
            message: [
                `Soup and chili can be loaded with sodium, but it's fine if you're just having it as a cup of soup alongside your meal. Skip the cheese and be careful with adding sour cream if you decide to go with chili.`,
            ]
        }
    ],
    section5: [
        {
            name: `Decadent Brownie Sundae`,
            correct: false,
            message: [
                `I'm pretty sure you knew this was going to be a poor choice before you even picked it. That's way too much sugar and fat.`,
                `Please make a different selection.`
            ]
        },
        {
            name: `Freshly Churned Ice Cream`,
            correct: true,
            message: [
                `You might be shocked to hear that it's okay to have a scoop of ice cream for dessert. Just be sure to inform your server that you're diabetic and skip over any sugary add-ons such as waffle cones. They also may have special options available for diabetic customers.`,
            ]
        },
        {
            name: `Pie of the Week`,
            correct: false,
            message: [
                `Pie is definitely not going to be a great choice. Even if it's made with fresh fruit, pie filling is loaded with tons of sugar, and pie crust itself has a lot of fat and carbs.`,
                `Please make a different selection.`
            ]
        },
        {
            name: `Fruit and Nut Yogurt Parfait`,
            correct: true,
            message: [
                `Mention to your server that you're a diabetic, and this could be a fine choice. As always, be sure to watch your serving size and follow the plate method. Try to stick to between 1/2 to 1 cup since it also has fruit and nuts.`,
            ]
        },
        {
            name: ``,
            correct: false,
            message: [
                ``,
            ]
        }
    ],
    section6: [
        {
            name: `Regular Soda`,
            correct: false,
            message: [
                `Just as with the plating method at home, you want to avoid regular soda due to the sugar content. Opt for a sugar-free or diet option instead.`,
                `Please make a different Drink selection.`
            ]
        },
        {
            name: `Diet Soda`,
            correct: true,
            message: [
                `While not as beneficial as milk or water, diet or sugar free soda is an okay choice.`,
            ]
        },
        {
            name: `Sweet Tea`,
            correct: false,
            message: [
                `Tea may seem like it's better than regular soda, but with sweet tea you're often getting a lot more added sugar than you really should.`,
                `Opt for unsweetened instead if you're having tea. Please make a different Drink selection.`
            ]
        },
        {
            name: `Iced Tea`,
            correct: true,
            message: [
                `Iced tea is a fine choice as long as it's unsweetened.`,
                `If you prefer to have your tea with some sweetness, ask for a sugar substitute when you order.`
            ]
        },
        {
            name: `Water`,
            correct: true,
            message: [
                `Water is a no-brainer when it comes to keeping your body hydrated.`,
                `The plating method suggests pairing a glass of milk with your meal, but water is also a perfectly acceptable choice when dining out somewhere.`
            ]
        }
    ],
    congrats: `CONGRATULATIONS!!! You’ve demonstrated that you understand the plate method well enough to make smart choices the next time you visit an American style restaurant.`
}
